export default __webpack_public_path__ + "static/media/logo_shahed.9122fe9e.png";